import { type ModuleData, ModuleProvider, useModule } from '#providers'
import { ClientInputsDto } from '../../types/authenticateSmartcheckSessionDto'

interface FlowCompletedConfig {
	isFinalFlow: boolean
	partOfMultiFlow: boolean
	regionId: string
	clientName: string
}

export interface FlowCompletedData {
	redirectUrlNoQueryParams?: string | null
	redirectUrl?: string
	shouldAutoCloseTabOnFlowCompletion: boolean
	shouldAllowOutputPdfDownload: boolean
	shouldAllowRedirectToNextSession: boolean
	shouldShowIndicationOfResult: boolean
	shouldRedirectWithoutDelay: boolean
	shouldAutoCloseTabWithoutDelay: boolean
	clientInputs?: ClientInputsDto
	isFinished: boolean
	hasIncomeVerification: boolean
	mainApplicantId?: string
}

export type FlowCompletedModuleData = ModuleData<
	FlowCompletedData,
	void,
	FlowCompletedConfig
>

export const FlowCompletedModuleProvider: typeof ModuleProvider<FlowCompletedModuleData> =
	ModuleProvider

export const useFlowCompletedModule: typeof useModule<FlowCompletedModuleData> =
	useModule
